import { Result } from '@ecoflow/ef-ui';
import { ComponentProps } from 'react';
import { t } from '@lingui/macro';

export default function AntdResult(props: ComponentProps<typeof Result>) {
    const subTitle = props.subTitle ? props.subTitle : <span style={{ color: 'rgba(0,0,0,0.5)' }}>{t`No data`}</span>;

    return (
        <Result
            icon={<CustomIcon />}
            style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', color: 'red' }}
            {...props}
            subTitle={subTitle}
        />
    );
}

function CustomIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="162px" height="162px" viewBox="0 0 162 162" version="1.1">
            <defs>
                <path
                    d="M81,0 C125.735065,-8.21769808e-15 162,36.2649353 162,81 C162,125.735065 125.735065,162 81,162 C36.2649353,162 5.47846538e-15,125.735065 0,81 C-5.47846538e-15,36.2649353 36.2649353,8.21769808e-15 81,0 Z"
                    id="path-1"
                />
            </defs>
            <g id="分析" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="分析-空" transform="translate(-1061, -560)">
                    <g id="pic/no-data" transform="translate(1061, 560)">
                        <mask id="mask-2" fill="white">
                            <use xlinkHref="#path-1" />
                        </mask>
                        <use id="Rectangle" fill="#E8EEF8" xlinkHref="#path-1" />
                        <rect
                            id="Rectangle"
                            strokeOpacity="0.0688374126"
                            stroke="#7096D4"
                            strokeWidth="2"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                            x="30"
                            y="45"
                            width="102"
                            height="134"
                            rx="6"
                        />
                        <rect id="Rectangle-Copy-2" fill="#B9D8F9" mask="url(#mask-2)" x="58" y="90" width="10" height="22" rx="1" />
                        <rect id="Rectangle-Copy-3" fill="#B9D8F9" mask="url(#mask-2)" x="94" y="81" width="10" height="31" rx="1" />
                        <rect id="Rectangle-Copy" fill="#E1EAF8" mask="url(#mask-2)" x="76" y="77" width="10" height="35" rx="1" />
                        <line x1="48" y1="112" x2="114" y2="112" id="Path" stroke="#E3E9F3" strokeWidth="2" mask="url(#mask-2)" />
                    </g>
                </g>
            </g>
        </svg>
    );
}
